import { getActiveUserProgramOptions } from "@/actions/user-program/queries";
import { ActiveProgramCard, MaxWeightsManager } from "@/components/profile";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useQuery } from "@tanstack/react-query";
import { Link, createFileRoute, redirect } from "@tanstack/react-router";
import { Dumbbell, Settings, User } from "lucide-react";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/profile")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    if (!context.user) {
      throw redirect({ to: "/" });
    }
  },
});

function RouteComponent() {
  const tabs = [
    { value: "overview", label: "Genel Bakış", icon: User },
    { value: "maxweights", label: "Max Ağırlıklar", icon: Dumbbell },
    { value: "settings", label: "Ayarlar", icon: Settings },
  ];

  return (
    <div className="container mx-auto max-w-6xl px-4 pt-24 pb-8">
      <div className="mb-8">
        <h1 className="font-bold text-3xl">Profil</h1>
        <p className="text-muted-foreground">
          Programınızı ve max ağırlıklarınızı yönetin
        </p>
      </div>

      <Tabs defaultValue="overview" className="w-full">
        <TabsList
          className={`grid h-auto w-full grid-cols-${tabs.length} gap-1 bg-transparent p-0 sm:h-10 sm:gap-2 sm:bg-muted sm:p-1`}
        >
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="flex flex-col gap-1 rounded-xl py-3 data-[state=active]:bg-secondary/20 sm:flex-row sm:rounded-lg sm:py-1.5 data-[state=active]:sm:bg-background"
            >
              <tab.icon className="h-4 w-4" />
              <span className="text-[10px] sm:text-sm">{tab.label}</span>
            </TabsTrigger>
          ))}
        </TabsList>

        {/* Overview Tab */}
        <TabsContent value="overview" className="space-y-6">
          <Suspense fallback={<ProgramCardSkeleton />}>
            <OverviewTab />
          </Suspense>
        </TabsContent>

        {/* Max Weights Tab */}
        <TabsContent value="maxweights" className="space-y-6">
          <MaxWeightsManager />
        </TabsContent>

        {/* Settings Tab */}
        <TabsContent value="settings">
          <Card>
            <CardContent className="py-12 text-center">
              <Settings className="mx-auto mb-4 h-12 w-12 text-muted-foreground" />
              <h3 className="mb-2 font-semibold text-lg">Yakında Gelecek</h3>
              <p className="text-muted-foreground">
                Hesap ayarları ve tercihler burada olacak
              </p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}

function OverviewTab() {
  const { data: activeProgramData } = useQuery(getActiveUserProgramOptions());

  const userProgram = activeProgramData?.body;

  if (!userProgram || "message" in userProgram) {
    return (
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12 text-center">
          <Dumbbell className="mb-4 h-12 w-12 text-muted-foreground" />
          <h3 className="mb-2 font-semibold text-lg">Aktif Program Yok</h3>
          <p className="mb-4 text-muted-foreground">
            Antrenman programı seçerek başlayabilirsin
          </p>
          <Button asChild>
            <Link to="/program">Programlara Göz At</Link>
          </Button>
        </CardContent>
      </Card>
    );
  }

  return <ActiveProgramCard userProgram={userProgram} />;
}

function ProgramCardSkeleton() {
  return (
    <Card>
      <CardContent className="space-y-4 p-6">
        <Skeleton className="h-6 w-2/3" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-2 w-full" />
        <Skeleton className="h-10 w-full" />
      </CardContent>
    </Card>
  );
}
